import { firestoreReducer } from 'redux-firestore'

export default firestoreReducer;
